import {
  TextInput,
  PasswordInput,
  Checkbox,
  Anchor,
  Paper,
  Title,
  Container,
  createStyles,
  Group,
  Button,
  Loader,
} from '@mantine/core';
import {useAppStore} from '../../store';
import {useForm} from '@mantine/form';
import {toast} from 'react-hot-toast';
import {UserInterface} from '../../models';
import useDocumentTitle from '../../hooks/useDocument';

const useStyles = createStyles(theme => {
  return {
    control: {
      backgroundColor: '#21485e',

      '&:not([data-disabled])': theme.fn.hover({
        backgroundColor: '#21485e',
        color: '#ffffff',
      }),
    },
  };
});

function LoginView() {
  useDocumentTitle('Admin login | Quality-Home-Healthcare');
  const {classes} = useStyles();
  const {usersStore} = useAppStore();

  const {loading, error} = usersStore.getters;

  const form = useForm({
    initialValues: {email: '', password: ''},
    // functions will be used to validate values at corresponding key
    validate: {
      email: value => (/^\S+@\S+$/.test(value) ? null : 'Invalid email'),
      password: value =>
        value.length < 6 ? 'Password should have at least 6 letters' : null,
    },
  });

  const login = async (formData: UserInterface) => {
    await usersStore.actions.loginUser(formData);
    if (error) {
      toast.error(error);
    } else {
    }
  };
  return (
    <div className="mt-5">
      <Container size={600} my={60} mt={40}>
        <Title
          align="center"
          sx={theme => ({
            fontFamily: `Greycliff CF, ${theme.fontFamily}`,
            fontWeight: 900,
          })}
        >
          Login
        </Title>
        <Paper withBorder shadow="md" p={30} mt={30} radius="md">
          <form onSubmit={form.onSubmit(values => login(values))}>
            <TextInput
              label="Email"
              placeholder="you@mantine.dev"
              required
              {...form.getInputProps('email')}
            />
            <PasswordInput
              label="Password"
              placeholder="Your password"
              size="xl"
              required
              mt="md"
              {...form.getInputProps('password')}
            />

            <Group position="apart" mt="lg">
              <Checkbox label="Remember me" />
              <Anchor component="button" size="sm" c={'#21485e'}>
                Forgot password?
              </Anchor>
            </Group>
            {loading ? (
              <Loader variant="dots" />
            ) : (
              <Button
                type="submit"
                className={classes.control}
                fullWidth
                mt="xl"
              >
                Sign in
              </Button>
            )}
          </form>
        </Paper>
      </Container>
    </div>
  );
}

export default LoginView;
